import { defineMessages } from 'react-intl';

export default defineMessages({
  submitting: {
    id: 'submitting',
    description: 'submitting',
    defaultMessage: 'Submitting...',
  },
  loading: {
    id: 'loading',
    description: 'loading',
    defaultMessage: 'Loading...',
  },
});
